<template>
  <div class="content">
    <Login />
    <PayInfo>
      <div class="mod">
        <Tips />
      </div>
      <QRCode />
      <BroadCast />
    </PayInfo>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PayInfo from '~/components/recharge/PayInfo'
import QRCode from '~/components/recharge/QRCode'
import Tips from '~/components/recharge/Tips'
import BroadCast from '~/components/recharge/BroadCast'
import Login from '~/components/recharge/Login'
export default {
  components: {
    PayInfo,
    QRCode,
    Tips,
    Login,
    BroadCast
  },
  computed: {
    ...mapGetters('recharge', ['curGame', 'rmb'])
  },
  created() {},
  methods: {
    getExt2() {
      const { curGame = {}, curArea = {}, userId } = this.$refs.role
      return {
        deliver_userid: userId,
        role_id: this.role.role_id,
        role_name: this.role.role_name,
        game_id: curGame.game_id + '',
        server_id: curArea.server_id,
        user_id: this.$cookies.get('userid')
      }
    },
    updateCode() {
      if (!this.$store.getters.isLogin) {
        return this.$store.commit('app/setLoginPop', true)
      }
      // this.role.role_id
      if (this.account && this.role.role_name && this.rmb > 0) {
        this.$nextTick(() => {
          this.$refs.qrcode.getQrCode(true)
        })
      }
    }
  }
}
</script>
